export const isSafariBrowser = () => {
  //safari detection
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isChromeBrowser = () => {
  var isChromium = window.chrome;
  var winNav = window.navigator;
  var vendorName = winNav.vendor;
  var isOpera = typeof window.opr !== "undefined";
  var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
  var isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    // is Google Chrome on IOS
    return false;
  } else if (
    isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false
  ) {
    // is Google Chrome
    return true;
  } else {
    // not Google Chrome
    return false;
  }
};

export const isFireFoxBrowser = () => {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
};
